import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector:
    '.m-grid__item.m-grid__item--fluid.m-grid.m-grid--ver-desktop.m-grid--desktop.m-body',
  templateUrl: './body.component.html',
  encapsulation: ViewEncapsulation.None
})
export class BodyComponent implements OnInit {
  constructor() { }
  ngOnInit() { }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/app/@layout/body/body.component.ts